import { render, staticRenderFns } from "./WarrantyModal.vue?vue&type=template&id=4c65dc3d&"
import script from "./WarrantyModal.vue?vue&type=script&lang=js&"
export * from "./WarrantyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports